// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"d1eadc01","3780":"e1bb790c","4768":"f10762c2"}[chunkId] + ".chunk.css";
};